import React, { useEffect, useReducer } from "react";
import { useSelector } from "react-redux";

// importation style
import "./style.css";

// importation icons
import { AddRounded, RemoveRounded } from "@mui/icons-material";


export default function Cart() {
    const cart = useSelector((state) => state.handleCart);
    const [, forceRender] = useReducer((s) => s + 1, 0);

    const addQty = (id) => {
        const c = cart.find((x) => x.id === id);

        if (c) {
            c.qty += 1;
            console.log(c.qty);
        }

        console.log({ hehta_el_state_mta3_el_cart: cart });
    };

    const removeQty = (id) => {
        const c = cart.find((x) => x.id === id);

        if (c) {
            c.qty -= 1;
            console.log(c.qty);
        }
        
        if ((c.qty <= 0)) {
            return cart.filter((x) => x.id !== id);
        }
        

    };


    useEffect(() => {
        forceRender()
    } , [cart] )

    return (
        <div className="cart">
            {cart.map((cart) => {
                return (
                    <div
                        key={cart.id}
                        className=" cart md:flex  py-9 bg-gray-50 my-5 "
                    >
                        <div className="image flex justify-center items-center m-auto  md:mb-0 mb-5 ">
                            <img src={cart.image} alt={cart.title} />
                        </div>

                        <div className="info flex items-center ">
                            <div className="container ">
                                <h2 className=" text-5xl mb-5 font-bold ">
                                    {cart.title}{" "}
                                </h2>
                                <p className=" text-4xl font-bold mb-5 ">
                                    {cart.qty} x {cart.price} = $
                                    {cart.qty * cart.price}{" "}
                                </p>
                                <button
                                    onClick={() => removeQty(cart.id)}
                                    className="btn p-2.5 mr-5 "
                                >
                                    <RemoveRounded />
                                </button>

                                <button
                                    onClick={() => addQty(cart.id)}
                                    className="btn p-2.5"
                                >
                                    <AddRounded />
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
